import React from "react";
import "./styles.scss";
import { ButtonGroup } from "reactstrap";

const RadioButton = ({ setter, value, disabled = false }) => {
  return (
    <ButtonGroup className="radio-button">
      <label htmlFor="unica">
        <input name="unica" id="unica" value="unica" type="radio" onClick={() => setter(1)} checked={value === 1} disabled={disabled} />
        Única
      </label>
      <label htmlFor="mensual">
        <input className="primary" name="mensual" id="mensual" value="mensual" type="radio" onClick={() => setter(2)} checked={value === 2} disabled={disabled} />
        Mensual
      </label>
    </ButtonGroup>
  );
};

export default RadioButton;
